import qs from 'qs'
import initAlphaLogin from './src/alpha'
import initWechatWebLogin from './src/wechatWebLogin'
import initWorkWxWebLogin from './src/workWechatWeb'
import initWorkWxWebAuth from './src/workWechatAuth'
import initFeishuWebAuth from './src/feishuWeb'
import { LOGIN_TYPES } from './constants'
import { setLocalLoginType, getLocalLoginType } from './core/loginType'

// 默认的登录方式
const DEFAULT_LOGIN_TYPE = LOGIN_TYPES.WORK_WECHAT_WEB

// 登录方式与class的map对照
const LoginTypeExampleMap = {
  // alpha登录
  [LOGIN_TYPES.ALPHA]: initAlphaLogin,
  // 微信web登录
  [LOGIN_TYPES.WECHAT_WEB]: initWechatWebLogin,
  // 企业微信扫码
  [LOGIN_TYPES.WORK_WECHAT_WEB]: initWorkWxWebLogin,
  // 企业微信授权
  [LOGIN_TYPES.WORK_WECHAT_AUTH]: initWorkWxWebAuth,
  // 飞书web扫码登录
  [LOGIN_TYPES.FEISHU_WEB]: initFeishuWebAuth
}

// 当前导出的登录模式和登录流程
const Login = {
  loginType: null, // 当前使用的登录方式
  value: null, // 登录相关方法集合
  destoryInitEffect: null // 销毁初始化登录方法的副作用
}

// 当前使用的登录方式，默认为workWechat
const _setLoginType = (newLoginType) => {
  Login.loginType = newLoginType
  setLocalLoginType(newLoginType)
}

// 使用何种登录方式，可使用枚举：LOGIN_TYPES
export const useLoginType = (loginType = DEFAULT_LOGIN_TYPE) => {
  // debugger
  // 使用了相同的登录方式
  if (loginType === Login.loginType)  { return console.warn('Using the same login method, this definition is invalid') }
  // 使用了未定义的登录方式
  if (!Object.values(LOGIN_TYPES).includes(loginType)) {
    // 如果login为空则切换默认的登录方式
    if (!Login.value) { useLoginType(DEFAULT_LOGIN_TYPE) }
    console.error('An undefined login method was used：', loginType)
    return false
  }
  // 销毁旧的登录方法 及 副作用
  if (typeof Login.destoryInitEffect === 'function') {
    Login.destoryInitEffect()
  }
  // 启用新的登录方法
  _setLoginType(loginType)
  const [value, destoryInitEffect] = LoginTypeExampleMap[loginType]()
  Login.value = value
  Login.destoryInitEffect = destoryInitEffect
  console.log('switch login type：', loginType, Login)
}

// 默认选择一个登录程序执行
const query = qs.parse(location.search.substring(1))
console.log('当前query的loginType', query, query.loginType)
useLoginType(query.loginType || getLocalLoginType() || DEFAULT_LOGIN_TYPE)

// export
export default Login